import { render, staticRenderFns } from "./BannerHistoryTabDataTable.vue?vue&type=template&id=dceefa76"
import script from "./BannerHistoryTabDataTable.vue?vue&type=script&lang=js"
export * from "./BannerHistoryTabDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports